import { Component, OnInit } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { AuthenticatedUser } from '@quorum/authentication/state';
import { filter, take } from 'rxjs/operators';
import { environment } from '@quorum/environments';

@Component({
  selector: 'quorum-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  authenticatedUser: AuthenticatedUser;

  constructor(private authenticationService: AuthenticationStateService) {
    this.authenticationService
      .selectAuthenticatedUser()
      .pipe(
        filter((authenticatedUser) => authenticatedUser != null),
        take(1)
      )
      .subscribe((authenticatedUser) => {
        this.authenticatedUser = authenticatedUser;
        if (environment.environment !== 'development') {
          datadogRum.init({
            applicationId: 'b9efb01b-9efe-4040-a42a-396b8c943601',
            clientToken: 'pub3dccc63eea50d18e77d9f1f6b2095888',
            site: 'datadoghq.com',
            service: 'power-lane',
            env: `${environment.environment}`,
            version: `${environment.version}`,
            sampleRate: 100,
            trackInteractions: true,
            allowedTracingOrigins: [`${environment.apiBase}`],
          });

          datadogRum.setUser({
            id: authenticatedUser.user.id.toString(),
            name: `${authenticatedUser.user.firstName} ${authenticatedUser.user.lastName}`,
            xselleratorAssociateId: authenticatedUser.user.xselleratorEmployeeId,
            destinationId: authenticatedUser.user.destination,
            storeId: authenticatedUser.user.storeId,
            storeName: authenticatedUser.user.storeName,
          });
        }
      });
  }

  ngOnInit() {}
}
